export default "__VITE_ASSET__BHMaCxV2__"